/**
 * Shared scheduling-link helpers.
 * Quick Setup (FormBuilder.jsx) is the only frontend flow that writes a
 * default calendar link — this upsert keeps that write idempotent so
 * re-running Quick Setup never creates duplicate `isDefault: true` docs.
 */

import { addDoc, collection, deleteDoc, getDocs, query, updateDoc, where } from 'firebase/firestore';
import { db } from '../firebase';

/**
 * Creates or updates the single default scheduling link for a workspace.
 * If more than one legacy default exists, the first is updated and the
 * rest are deleted so exactly one default remains.
 */
export async function upsertDefaultSchedulingLink({ workspaceId, url, assignedTo }) {
  const existing = await getDocs(query(
    collection(db, 'scheduling_links'),
    where('workspaceId', '==', workspaceId),
    where('isDefault', '==', true)
  ));

  if (!existing.empty) {
    await updateDoc(existing.docs[0].ref, { url, updatedAt: new Date() });
    for (let i = 1; i < existing.docs.length; i++) {
      await deleteDoc(existing.docs[i].ref);
    }
    return existing.docs[0].ref;
  }

  return addDoc(collection(db, 'scheduling_links'), {
    workspaceId,
    label: 'Default Calendar',
    url,
    assignedTo: assignedTo || '',
    isDefault: true,
    routingRules: { keywords: [], priority: 1 },
    createdAt: new Date(),
    updatedAt: new Date(),
  });
}
